import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useEffect, useMemo, useRef, useState } from 'react'
import redirectURL from "../../redirectURL";
import moment from 'moment'
import Loader from '../../mainpage/Loader';
import Icon from '../../../assets/icons/truck-fleet.png'
import Icon2 from '../../../assets/icons/truck-intransit.png'
import { fetchGridLayout, getDecoder, getHyphenDDMMMYYYYHHMM, saveGridLayout } from '../../common/utils';
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

export default function VehicleDashboard() {

    const user = useMemo(() => getDecoder(), []);
    const [show, setShow] = useState(false)
    const [type, setType] = useState('default')
    const [title, setTitle] = useState('')
    const [counter, setCounter] = useState('All Vehicle Details ')
    const [subCounter, setSubCounter] = useState('')
    const [subCounterCount, setSubCounterCount] = useState({ 0: 0, 30: 0, 3060: 0, 60: 0 })
    const gridColumnState = useRef(null)
    const columnApi = useRef(null)
    const chart1 = useRef(null)
    const chart2 = useRef(null)
    const chart3 = useRef(null)
    const chart4 = useRef(null)
    const [consVehicles, setConsVehicles] = useState([])
    const [allVehicles, setAllVehicles] = useState([])
    const [loader, setLoader] = useState(false)
    const [rowData, setRowData] = useState([])
    const [allData, setAllData] = useState({
        insuranceExp00: [],
        insuranceExp30: [],
        insuranceExp: [],
        insuranceExp60: [],
        permitExp00: [],
        permitExp30: [],
        permitExp: [],
        permitExp60: [],
        fitnessExp00: [],
        fitnessExp30: [],
        fitnessExp: [],
        fitnessExp60: [],
        registrationExp00: [],
        registrationExp30: [],
        registrationExp: [],
        registrationExp60: [],
        insuranceExp00Len: 0,
        insuranceExp30Len: 0,
        insuranceExpLen: 0,
        insuranceExp60Len: 0,
        permitExp00Len: 0,
        permitExp30Len: 0,
        permitExpLen: 0,
        permitExp60Len: 0,
        fitnessExp00Len: 0,
        fitnessExp30Len: 0,
        fitnessExpLen: 0,
        fitnessExp60Len: 0,
        registrationExp00Len: 0,
        registrationExp30Len: 0,
        registrationExpLen: 0,
        registrationExp60Len: 0,
    })
    const coloumnDefs = useMemo(() => {
        return [
            {
                headerName: "Vehicle No.",
                field: "truck_no",
                width: 122,
            },
            {
                headerName: "Vehicle Type",
                field: "vehicle_type",
                // },
            },
            {
                headerName: "Transporter Code",
                field: "transporter_code",
                width: 158,
            },
            {
                headerName: "Transporter Name",
                field: "transporter_name",
            },
            {
                headerName: "Chassis Number",
                field: "chassis_number",
            },
            {
                headerName: "Engine Number",
                field: "engine_number",
            },
            {
                headerName: "Fitness Upto",
                field: "fitness_upto",
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.fitness_upto)
                },
                comparator: dateComparator,
            },
            {
                headerName: "Fuel Description",
                field: "fuel_description",
            },
            {
                headerName: "Insurance Policy Number",
                field: "insurance_policy_number",
            },
            {
                headerName: "Insurance Validity",
                field: "insurance_validity",
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.insurance_validity)
                },
                comparator: dateComparator,
            },
            {
                headerName: "Owner Code Description",
                field: "owner_code_description",
            },
            {
                headerName: "Permit Number",
                field: "permit_number",
            },
            {
                headerName: "Permit Valid From",
                field: "permit_valid_from",
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.permit_valid_from)
                },
                comparator: dateComparator,
            },
            {
                headerName: "Permit Valid To",
                field: "permit_validity",
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.permit_validity)
                },
                comparator: dateComparator,
            },
            {
                headerName: "PUCC Number",
                field: "pucc_number",
            },
            {
                headerName: "PUCC Upto",
                field: "pucc_upto",
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.pucc_upto)
                },
                comparator: dateComparator,
            },
            {
                headerName: "Registration Date",
                field: "registration_date",
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.registration_date)
                },
                comparator: dateComparator,
            },
            {
                headerName: "Registration Validity",
                field: "registration_validity",
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.registration_validity)
                },
                comparator: dateComparator,
            },
            {
                headerName: "Vehicle Category",
                field: "vehicle_category",
            },
            {
                headerName: "Vehicle Class Desc",
                field: "vehicle_class_desc",
            },
            {
                headerName: "Vehicle Status",
                field: "vehicle_status",
            },
             {
                headerName: "User Fitness Upto",
                field: "mbl_fitness_upto",
                valueGetter: function (params) {
                    if (params.data?.mbl_fitness_upto != undefined && params.data?.mbl_fitness_upto != null && params.data?.mbl_fitness_upto != ""){
                        return getHyphenDDMMMYYYYHHMM(params.data.mbl_fitness_upto)
                    }
                    return ""
                }
            },
            {
                headerName: "User Insurance Validity",
                field: "mbl_insurance_validity",
                valueGetter: function (params) {
                     if (params.data?.mbl_insurance_validity != undefined && params.data?.mbl_insurance_validity != null && params.data?.mbl_insurance_validity != ""){
                        return getHyphenDDMMMYYYYHHMM(params.data.mbl_insurance_validity)
                    }
                    return ""
                }
            },
            {
                headerName: "User PUCC Upto",
                field: "mbl_pucc_upto",
                valueGetter: function (params) {
                     if (params.data?.mbl_pucc_upto != undefined && params.data?.mbl_pucc_upto != null && params.data?.mbl_pucc_upto != ""){
                        return getHyphenDDMMMYYYYHHMM(params.data.mbl_pucc_upto)
                    }
                    return ""
                }
            },
            {
                headerName: "User Registration Validity",
                field: "mbl_registration_validity",
                valueGetter: function (params) {

                     if (params.data?.mbl_registration_validity != undefined && params.data?.mbl_registration_validity != null && params.data?.mbl_registration_validity != ""){
                        return getHyphenDDMMMYYYYHHMM(params.data.mbl_registration_validity)
                    }
                    return ""
                },
            },
            {
                headerName: "Vehicle Make",
                field: "vehicle_make",
            },
            {
                headerName: "Vehicle Model",
                field: "vehicle_model",
            },
            {
                headerName: "Vehicle Body Type",
                field: "vehicle_body_type",
            },
            {
                headerName: "Vehicle Unloaded Weight",
                field: "vehicle_unloaded_wt",
            },
            {
                headerName: "Vehicle Gross Weight",
                field: "vehicle_gross_wt",
            },
            {
                headerName: "Vehicle Cubic Capacity",
                field: "vehicle_cubic_capacity",
            },
            {
                headerName: "Vehicle Model CD",
                field: "vehicle_model_cd",
            },
            {
                headerName: "Permit Type",
                field: "permit_type",
            },
        ]
    }, [])
    const defaultColumnDef = useMemo(() => {
        return {
            sortable: true,
            filter: true,
            resizable: true
        }
    }, [])

    const onGridReady = async (params) => {
        await fetchGridLayout(user?.email, "vehicle_health_dashboard")
            .then(async res => {
                if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                    setTimeout(async () => {
                        await params.api.applyColumnState({
                            state: res.data.data[0].columnState,
                            applyOrder: true,
                        })
                    }, 1000);
                    gridColumnState.current = res.data.data[0].columnState
                }
            })
            .catch(err => console.log(err))
    };
    const saveGrid = async (e) => {
        let coloumnState = columnApi.current.api.getColumnState()
        let temp = await saveGridLayout(user.email, "vehicle_health_dashboard", coloumnState)
        gridColumnState.current = coloumnState
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully updated")
            setType("success")
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }
    const resetGrid = async (e) => {
        let coloumnState = []
        let temp = await saveGridLayout(user.email, "vehicle_health_dashboard", coloumnState)
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully reset")
            setType("success")
            columnApi.current.api.resetColumnState()
        }
        else {
            setShow(true)
            setTitle("Failed to reset grid")
            setType("danger")
        }
    }
    const getRowStyle = (params) => {
        if (subCounter == "") {
            if (params.data.alert_color_amber == 1) {
                return { backgroundColor: '#ffbf00' };
            }
            if (params.data.alert_color_red == 1) {
                return { backgroundColor: '#FF8080' };
            }
            if (params.data.alert_color_dark_red == 1) {
                return { backgroundColor: '#FF4040' };
            }
        }
        else {
            if (subCounter === -1) {
                return { backgroundColor: '#FF4040' };
            }
            if (subCounter === 3060) {
                return { backgroundColor: '#ffbf00' };
            }
            if (subCounter === 30) {
                return { backgroundColor: '#FF8080' };
            }
        }
        return undefined;
    }
    useEffect(() => {
        setLoader(true)
        redirectURL.post("/dashboard/getVehicleHealth", {})
            .then((response) => {
                fragmentData(response.data.vehicles)
                setAllVehicles(response.data.vehicles)
                setConsVehicles(response.data.vehicles.filter(e => response.data.cons_vehicles.includes(e.truck_no)))
            })
            .catch(function (e) {
                setLoader(false)
                console.log(e)
            })
    }, [])

    const fragmentData = (vehicles) => {
        let insuranceExp00 = []
        let insuranceExp30 = []
        let insuranceExp = []
        let insuranceExp60 = []
        let permitExp00 = []
        let permitExp30 = []
        let permitExp = []
        let permitExp60 = []
        let fitnessExp00 = []
        let fitnessExp30 = []
        let fitnessExp = []
        let fitnessExp60 = []
        let registrationExp00 = []
        let registrationExp30 = []
        let registrationExp = []
        let registrationExp60 = []

        vehicles.forEach(each => {
            if (each.insurance_validity != undefined && each.insurance_validity != "") {
                let insurance = moment(each.insurance_validity).startOf('day').diff(moment(new Date(moment(new Date()).format("YYYY-MM-DD") + " 23:59:59")).startOf('day'), 'days')
                if (insurance <= 0) {
                    insuranceExp00.push(each)
                    each["alert_color_dark_red"] = 1
                }
                else if (insurance > 0 && insurance <= 30) {
                    insuranceExp30.push(each)
                    each["alert_color_red"] = 1
                }
                else if (insurance > 30 && insurance <= 60) {
                    insuranceExp.push(each)
                    each["alert_color_amber"] = 1
                }
                else if (insurance > 60)
                    insuranceExp60.push(each)
            }
            if (each.permit_validity != undefined && each.permit_validity != "") {
                let permit = moment(each.permit_validity).startOf('day').diff(moment(new Date(moment(new Date()).format("YYYY-MM-DD") + " 23:59:59")).startOf('day'), 'days')
                if (permit <= 0) {
                    permitExp00.push(each)
                    each["alert_color_dark_red"] = 1
                }
                else if (permit > 0 && permit <= 30) {
                    permitExp30.push(each)
                    each["alert_color_red"] = 1
                }
                else if (permit > 30 && permit <= 60) {
                    permitExp.push(each)
                    each["alert_color_amber"] = 1
                }
                else if (permit > 60)
                    permitExp60.push(each)
            }
            if (each.registration_validity != undefined && each.registration_validity != "") {
                let registration = moment(each.registration_validity).startOf('day').diff(moment(new Date(moment(new Date()).format("YYYY-MM-DD") + " 23:59:59")).startOf('day'), 'days')
                if (registration <= 0) {
                    registrationExp00.push(each)
                    each["alert_color_dark_red"] = 1
                }
                else if (registration > 0 && registration <= 30) {
                    registrationExp30.push(each)
                    each["alert_color_red"] = 1
                }
                else if (registration > 30 && registration <= 60) {
                    registrationExp.push(each)
                    each["alert_color_amber"] = 1
                }
                else if (registration > 60)
                    registrationExp60.push(each)
            }
            if (each.fitness_upto != undefined && each.fitness_upto != "") {
                let fitness = moment(each.fitness_upto).startOf('day').diff(moment(new Date(moment(new Date()).format("YYYY-MM-DD") + " 23:59:59")).startOf('day'), 'days')
                if (fitness <= 0) {
                    fitnessExp00.push(each)
                    each["alert_color_dark_red"] = 1
                }
                else if (fitness > 0 && fitness <= 30) {
                    fitnessExp30.push(each)
                    each["alert_color_red"] = 1
                }
                else if (fitness > 30 && fitness <= 60) {
                    fitnessExp.push(each)
                    each["alert_color_amber"] = 1
                }
                else if (fitness > 60)
                    fitnessExp60.push(each)
            }
        })
        setAllData({
            insuranceExp00,
            insuranceExp30,
            insuranceExp,
            insuranceExp60,
            fitnessExp00,
            fitnessExp30,
            fitnessExp,
            fitnessExp60,
            permitExp00,
            permitExp30,
            permitExp,
            permitExp60,
            registrationExp00,
            registrationExp30,
            registrationExp,
            registrationExp60,
            insuranceExp00Len: insuranceExp00.length,
            insuranceExp30Len: insuranceExp30.length,
            insuranceExpLen: insuranceExp.length,
            insuranceExp60Len: insuranceExp60.length,
            permitExp00Len: permitExp00.length,
            permitExp30Len: permitExp30.length,
            permitExpLen: permitExp.length,
            permitExp60Len: permitExp60.length,
            fitnessExp00Len: fitnessExp00.length,
            fitnessExp30Len: fitnessExp30.length,
            fitnessExpLen: fitnessExp.length,
            fitnessExp60Len: fitnessExp60.length,
            registrationExp00Len: registrationExp00.length,
            registrationExp30Len: registrationExp30.length,
            registrationExpLen: registrationExp.length,
            registrationExp60Len: registrationExp60.length,
            loadshow: 'show-n',
            showform: 'show-n',
        })
        setLoader(false)
        setRowData(vehicles)
    }

    // Donut chart options for Vehicle Fitness
    // const donutOptions = {
    //     chart: {
    //         type: 'pie',
    //         backgroundColor: 'transparent',
    //         height: 150
    //     },
    //     title: {
    //         text: `<b>${allData.vehiclesLen}</b></br><label>Vehicles</label>`,  // The text you want in the center
    //         verticalAlign: 'middle',
    //         horizontalAlign: 'center',
    //         style: {
    //             fontSize: '16px',
    //             fontWeight: 'bold',
    //             color: '#000'
    //         }
    //     },
    //     legend: {
    //         enabled: false
    //     },
    //     plotOptions: {
    //         pie: {
    //             innerSize: '80%',
    //             dataLabels: {
    //                 enabled: false
    //             }
    //         }
    //     },
    //     series: [{
    //         name: 'Vehicles',
    //         data: [
    //             ['Active', allData.vehiclesLen - allData.vehiclesFitnessExpLen],
    //             ['Expired', allData.vehiclesFitnessExpLen]
    //         ],
    //         colors: ['#FF4040', '#FF8080']
    //     }]
    // };
    console.log(allData, "allData.fitnessExp00Len");

    const fitnessOptions = {
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300
        },
        title: {
            text: ''
        },
        xAxis: {
            title: {
                text: ''
            },
            categories: ['Expired', '0-30 Days', '30-60 Days'],
            colorByPoint: true,
        },
        yAxis: {
            title: {
                // text: 'No. of Vehicles'
                text: ''
            }
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            column: {
                pointPadding: 0.26,  // Controls space between bars (default is 0.1)
                groupPadding: 0.05,  // Controls space between groups (default is 0.2)
                borderWidth: 0,     // Removes borders around columns (optional)
            }
        },
        series: [{
            name: 'Vehicles',
            data: [allData.fitnessExp00Len, allData.fitnessExp30Len, allData.fitnessExpLen],
            colors: ['#FF4040', '#FF8080', '#ffbf00'],
            colorByPoint: true,
            groupPadding: 0,
        }],
        credits: {
            enabled: false
        }
    }
    // Bar chart options for Insurance Expiry
    const insuranceOptions = {
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300
        },
        title: {
            text: ''
        },
        xAxis: {
            title: {
                text: ''
            },
            categories: ['Expired', '0-30 Days', '30-60 Days'],
            colorByPoint: true,
        },
        yAxis: {
            title: {
                // text: 'No. of Vehicles'
                text: ''
            }
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            column: {
                pointPadding: 0.26,  // Controls space between bars (default is 0.1)
                groupPadding: 0.05,  // Controls space between groups (default is 0.2)
                borderWidth: 0,     // Removes borders around columns (optional)
            }
        },
        series: [{
            name: 'Vehicles',
            data: [allData.insuranceExp00Len, allData.insuranceExp30Len, allData.insuranceExpLen],
            colors: ['#FF4040', '#FF8080', '#ffbf00', '#00c853'],  // Specific colors for each column
            colorByPoint: true,
            groupPadding: 0,
        }],
        credits: {
            enabled: false
        }
    }
    const permitOptions = {
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300
        },
        title: {
            text: ''
        },
        xAxis: {
            title: {
                text: ''
            },
            categories: ['Expired', '0-30 Days', '30-60 Days'],
            colorByPoint: true,
        },
        yAxis: {
            title: {
                // text: 'No. of Vehicles'
                text: ''
            }
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            column: {
                pointPadding: 0.26,  // Controls space between bars (default is 0.1)
                groupPadding: 0.05,  // Controls space between groups (default is 0.2)
                borderWidth: 0,     // Removes borders around columns (optional)
            }
        },
        series: [{
            name: 'Vehicles',
            data: [allData.permitExp00Len, allData.permitExp30Len, allData.permitExpLen],
            colors: ['#FF4040', '#FF8080', '#ffbf00', '#00c853'],  // Specific colors for each column
            colorByPoint: true,
            groupPadding: 0,
        }],
        credits: {
            enabled: false
        }
    }
    const registrationOptions = {
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300
        },
        title: {
            text: ''
        },
        xAxis: {
            title: {
                text: ''
            },
            categories: ['Expired', '0-30 Days', '30-60 Days'],
            colorByPoint: true,
        },
        yAxis: {
            title: {
                // text: 'No. of Vehicles'
                text: ''
            }
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            column: {
                pointPadding: 0.26,  // Controls space between bars (default is 0.1)
                groupPadding: 0.05,  // Controls space between groups (default is 0.2)
                borderWidth: 0,     // Removes borders around columns (optional)
            }
        },
        series: [{
            name: 'Vehicles',
            data: [allData.registrationExp00Len, allData.registrationExp30Len, allData.registrationExpLen],
            colors: ['#FF4040', '#FF8080', '#ffbf00', '#00c853'],  // Specific colors for each column
            colorByPoint: true,
            groupPadding: 0,
        }],
        credits: {
            enabled: false
        }
    }

    const SubCounterClick = (ecounter) => {
        switch (ecounter) {
            case -1:
                switch (counter) {
                    case "Vehicle Fitness Expiry ":
                        setRowData(allData.fitnessExp00)
                        break;
                    case "Vehicle Insurance Expiry ":
                        setRowData(allData.insuranceExp00)
                        break;
                    case "Permit Expiry ":
                        setRowData(allData.permitExp00)
                        break;
                    case "Registration Expiry ":
                        setRowData(allData.registrationExp00)
                        break;
                }
                setSubCounter(-1)
                break;
            case 30:
                switch (counter) {
                    case "Vehicle Fitness Expiry ":
                        setRowData(allData.fitnessExp30)
                        break;
                    case "Vehicle Insurance Expiry ":
                        setRowData(allData.insuranceExp30)
                        break;
                    case "Permit Expiry ":
                        setRowData(allData.permitExp30)
                        break;
                    case "Registration Expiry ":
                        setRowData(allData.registrationExp30)
                        break;
                }
                setSubCounter(30)
                break;
            case 3060:
                switch (counter) {
                    case "Vehicle Fitness Expiry ":
                        setRowData(allData.fitnessExp)
                        break;
                    case "Vehicle Insurance Expiry ":
                        setRowData(allData.insuranceExp)
                        break;
                    case "Permit Expiry ":
                        setRowData(allData.permitExp)
                        break;
                    case "Registration Expiry ":
                        setRowData(allData.registrationExp)
                        break;
                }
                setSubCounter(3060)
                break;
            case 60:
                switch (counter) {
                    case "Vehicle Fitness Expiry ":
                        setRowData(allData.fitnessExp60)
                        break;
                    case "Vehicle Insurance Expiry ":
                        setRowData(allData.insuranceExp60)
                        break;
                    case "Permit Expiry ":
                        setRowData(allData.permitExp60)
                        break;
                    case "Registration Expiry ":
                        setRowData(allData.registrationExp60)
                        break;
                }
                setSubCounter(60)
                break;
            default:
                break;
        }
    }

    const ViewDetailsClick = (counter) => {
        switch (counter) {
            case "cons_vehicles":
                fragmentData(consVehicles)
                setRowData(consVehicles)
                setSubCounterCount({ 0: 0, 30: 0, 3060: 0, 60: 0 })
                setCounter("Active Vehicles Details ")
                setSubCounter('')
                break;
            case "vehicles":
                fragmentData(allVehicles)
                setRowData(allVehicles)
                setSubCounterCount({ 0: 0, 30: 0, 3060: 0, 60: 0 })
                setCounter("All Vehicle Details ")
                setSubCounter('')
                break;
            case "fitness":
                setRowData([...allData.fitnessExp00, ...allData.fitnessExp, ...allData.fitnessExp30, ...allData.fitnessExp60])
                setSubCounterCount({ 0: allData.fitnessExp00Len, 30: allData.fitnessExp30Len, 3060: allData.fitnessExpLen, 60: allData.fitnessExp60Len })
                setCounter("Vehicle Fitness Expiry ")
                setSubCounter('')
                break;
            case "insurance":
                setRowData([...allData.insuranceExp00, ...allData.insuranceExp, ...allData.insuranceExp30, ...allData.insuranceExp60])
                setSubCounterCount({ 0: allData.insuranceExp00Len, 30: allData.insuranceExp30Len, 3060: allData.insuranceExpLen, 60: allData.insuranceExp60Len })
                setCounter("Vehicle Insurance Expiry ")
                setSubCounter('')
                break;
            case "permit":
                setRowData([...allData.permitExp00, ...allData.permitExp, ...allData.permitExp30, ...allData.permitExp60])
                setSubCounterCount({ 0: allData.permitExp00Len, 30: allData.permitExp30Len, 3060: allData.permitExpLen, 60: allData.permitExp60Len })
                setCounter("Permit Expiry ")
                setSubCounter('')
                break;
            case "registration":
                setRowData([allData.registrationExp00, ...allData.registrationExp, ...allData.registrationExp30, ...allData.registrationExp60])
                setSubCounterCount({ 0: allData.registrationExp00Len, 30: allData.registrationExp30Len, 3060: allData.registrationExpLen, 60: allData.registrationExp60Len })
                setCounter("Registration Expiry ")
                setSubCounter('')
                break;
            default:
                break;
        }
    }

    const onConfirm = () => {
        setShow(false);
        setTitle('')
        setType('default')
    };

    return (
        <div className="container-fluid" style={{ paddingLeft: "0px" }}>
            <SweetAlert
                show={show}
                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                onConfirm={onConfirm}
                confirmBtnBsStyle={type}
                confirmBtnCssClass="sweetButton"
                customClass='sweetWidth'
                type={type}>
            </SweetAlert>
            <Loader show={loader} />
            <h5 className="mb-15p fbold f20">
                <i className="fa fa-truck cus-i"></i><span style={{ fontWeight: "600" }}>  Vehicle Health Dashboard</span>
            </h5>
            <div className='row'>
                <div className={"col card trucks-card " + (counter == "All Vehicle Details " ? "chart-active" : "")} onClick={() => ViewDetailsClick("vehicles")} style={{ marginInlineEnd: "0.5rem" }}>
                    <img src={Icon} style={{ width: "4.4rem", paddingLeft: "8px" }} />
                    <div className={"header-color " + (counter == "All Vehicle Details " ? "vh-card-label" : "")} style={{ paddingInline: "1rem", paddingBlock: "0.7rem" }}>
                        <span style={{ fontSize: "16px", color: "#5C5C5C" }}>Total No. of Vehicles</span><br />
                        <span style={{ fontSize: "18px", fontWeight: "bold", color: "#000" }}>{allVehicles.length}</span>
                    </div>
                </div>
                <div className={"col card trucks-card " + (counter == "Active Vehicles Details " ? "chart-active" : "")} onClick={() => ViewDetailsClick("cons_vehicles")}>
                    <img src={Icon2} style={{ width: "4.4rem", paddingLeft: "8px" }} />
                    <div className={"header-color " + (counter == "Active Vehicles Details " ? "vh-card-label" : "")} style={{ paddingInline: "1rem", paddingBlock: "0.7rem" }}>
                        <span style={{ fontSize: "16px", color: "#5C5C5C" }}>Total No. of Active Vehicles</span><br />
                        <span style={{ fontSize: "18px", fontWeight: "bold", color: "#000" }}>{consVehicles.length}</span>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className={"col margin-inline-05 card " + (counter == "Vehicle Fitness Expiry " ? "chart-active" : "")} onClick={() => ViewDetailsClick("fitness")} style={{ cursor: "pointer" }}>
                    <div className={"header-color " + (counter == "Vehicle Fitness Expiry " ? "vh-card-label" : "")} >
                        <span>Vehicle Fitness Expiry </span>
                    </div>
                    <HighchartsReact ref={chart1} highcharts={Highcharts} options={fitnessOptions} />
                    <div className="text-center my-1">
                        <span className="chart-view-details">View Details</span>
                    </div>
                </div>

                {/* Vehicle Insurance Expiry Card */}
                <div className={"col margin-inline-05 card " + (counter == "Vehicle Insurance Expiry " ? "chart-active" : "")} onClick={() => ViewDetailsClick("insurance")} style={{ cursor: "pointer" }}>
                    <div className={"header-color " + (counter == "Vehicle Insurance Expiry " ? "vh-card-label" : "")} >
                        <span>Vehicle Insurance Expiry</span>
                    </div>
                    <HighchartsReact ref={chart2} highcharts={Highcharts} options={insuranceOptions} />
                    <div className="text-center my-1">
                        <span className="chart-view-details">View Details</span>
                    </div>
                </div>
                {/* Permit Expiry Card */}
                <div className={"col margin-inline-05 card " + (counter == "Permit Expiry " ? "chart-active" : "")} onClick={() => ViewDetailsClick("permit")} style={{ cursor: "pointer" }}>
                    <div className={"header-color " + (counter == "Permit Expiry " ? "vh-card-label" : "")} >
                        <span>Permit Expiry</span>
                    </div>
                    <HighchartsReact
                        highcharts={Highcharts}
                        ref={chart3} options={permitOptions} />
                    <div className="text-center my-1">
                        <span className="chart-view-details">View Details</span>
                    </div>
                </div>
                {/* Registration Expiry Card */}
                <div className={"col margin-inline-05 card " + (counter == "Registration Expiry " ? "chart-active" : "")} onClick={() => ViewDetailsClick("registration")} style={{ cursor: "pointer" }}>
                    <div className={"header-color " + (counter == "Registration Expiry " ? "vh-card-label" : "")} >
                        <span>Registration Expiry</span>
                    </div>
                    <HighchartsReact
                        highcharts={Highcharts}
                        ref={chart4}
                        options={registrationOptions} />
                    <div className="text-center my-1">
                        <span className="chart-view-details">View Details</span>
                    </div>
                </div>
            </div>
            {/* Data Grid */}
            <div className="row">
                <div className="col card">
                    <div className="card-header pt-10px" >
                        <div className="col-xl-12 col-lg-12 main-page-display">
                            <div style={{ display: 'flex', alignItems: "center" }}>
                                <h5>
                                    {counter}
                                </h5>
                            </div>
                            <div>
                                <span className="layoutbtns float-right">
                                    <div className="col-sm-12" style={{ display: "flex", alignItems: "center" }}>
                                        <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                                            <i className="fa fa-circle" style={{ fontSize: "20px", color: "#FF4040" }}></i>&nbsp;&nbsp;Expired
                                        </button>
                                        <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                                            <i className="fa fa-circle" style={{ fontSize: "20px", color: "#FF8080" }}></i>&nbsp;&nbsp;Expires in 30 Days
                                        </button>
                                        <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                                            <i className="fa fa-circle" style={{ fontSize: "20px", color: "#ffbf00" }}></i>&nbsp;&nbsp;Expires in 30 to 60 Days
                                        </button>
                                        <button type="button" title="Save Grid Layout" name="savegrid" className="btn btn-success float-right action_btn" style={{ marginLeft: "10px" }} onClick={saveGrid}> <i className="fa fa-save"></i> </button>
                                        <button type="button" title="Reset Grid Layout" name="resetgrid" className="btn btn-info float-right action_btn" style={{ marginLeft: "10px" }} onClick={resetGrid}> <i className="fa fa-reply"></i> </button>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="col-xl-12 col-lg-12 main-page-display">
                            {
                                (counter != undefined && counter != "All Vehicle Details " && counter != "Active Vehicles Details ") ?
                                    <div>
                                        <button className={`header-counter ${subCounter === -1 ? "active" : ""}`} style={{ marginLeft: "0px" }} onClick={() => SubCounterClick(-1)}>Expired: {subCounterCount[0]}</button>
                                        <button className={`header-counter ${subCounter === 30 ? "active" : ""}`} onClick={() => SubCounterClick(30)}>In 0 to 30 Days: {subCounterCount[30]}</button>
                                        <button className={`header-counter ${subCounter === 3060 ? "active" : ""}`} onClick={() => SubCounterClick(3060)}>In 30 to 60 Days: {subCounterCount[3060]}</button>
                                        <button className={`header-counter ${subCounter === 60 ? "active" : ""}`} onClick={() => SubCounterClick(60)}>After 60 Days: {subCounterCount[60]}</button>
                                    </div> : <></>
                            }
                        </div>
                    </div>
                    <div className="row card-body pt-15px" >
                        <div id="myGrid" style={{ height: "550px", width: "100%" }} className="col-xl-12 col-lg-12 ag-theme-balham">
                            <AgGridReact
                                ref={columnApi}
                                columnDefs={coloumnDefs}
                                defaultColDef={defaultColumnDef}
                                rowData={rowData}
                                enableCharts={true}
                                enableRangeSelection={true}
                                onGridReady={onGridReady}
                                sideBar={{
                                    toolPanels: [
                                        {
                                            id: "columns",
                                            labelDefault: "Columns",
                                            labelKey: "columns",
                                            iconKey: "columns",
                                            toolPanel: "agColumnsToolPanel",
                                            toolPanelParams: {
                                                suppressPivotMode: true,
                                                suppressRowGroups: true,
                                                suppressValues: true,
                                            }
                                        },
                                        {
                                            id: "filters",
                                            labelDefault: "Filters",
                                            labelKey: "filters",
                                            iconKey: "filter",
                                            toolPanel: "agFiltersToolPanel"
                                        }
                                    ]
                                }}
                                statusBar={{
                                    statusPanels: [
                                        {
                                            statusPanel: "agTotalAndFilteredRowCountComponent",
                                            align: "left"
                                        },
                                        {
                                            statusPanel: "agTotalRowCountComponent",
                                            align: "center"
                                        },
                                        { statusPanel: "agFilteredRowCountComponent" },
                                        { statusPanel: "agSelectedRowCountComponent" },
                                        { statusPanel: "agAggregationComponent" }
                                    ]
                                }}
                                paginationPageSize={100}
                                pagination={true}
                                masterDetail={true}
                                suppressCellFlash={true}
                                getRowStyle={getRowStyle}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

function dateComparator(date1, date2) {
    // console.log("dateComparator");
    // console.log(date1.length);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
        date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
        date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
        // console.log(date1,date2);
        var date1Number = monthToComparableNumber(date1);
        var date2Number = monthToComparableNumber(date2);
        // console.log(date1Number,date2Number);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}


function monthToComparableNumber(date) {
    // console.log(date,date.length);
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}

function getMonthNumber(monthName) {
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
    ];
    var monthNum = months.indexOf(monthName) + 1;
    if (monthNum < 10) {
        monthNum = "0" + monthNum.toString();
    }
    return monthNum;
}


{/* <div className='col margin-inline-05'>
    <div className={"col card " + (counter == "Vehicle Fitness Expiry " ? "chart-active" : "")} onClick={() => ViewDetailsClick("fitness")} style={{ cursor: "pointer" }}>
        <div className={"header-color " + (counter == "Vehicle Fitness Expiry " ? "vh-card-label" : "")} >
            <span>Vehicle Fitness Expiry</span>
        </div>
        <HighchartsReact ref={chart1} highcharts={Highcharts} options={fitnessOptions} />
        <div className='vehicle-fitness-bottom-div'>
            <div>
                <HighchartsReact ref={chart1} highcharts={Highcharts} options={donutOptions} />
                <div className='vehicle-fitness-div'>
                    <span style={{ fontSize: "18px", color: "#000000" }}>{allData.vehiclesFitnessExpLen}</span>
                    <span style={{ fontSize: "11px", color: "#646464" }}>Vehicle Fitness Expired</span>
                </div>
            </div>
            <div className="text-center my-1">
                <span className="chart-view-details">View Details</span>
            </div>
        </div>
    </div>
</div> */}